import cookies from 'js-cookie';
import store from '@/store';

import { getCode } from '@/utils/index.js';
import { live_time_options } from '@/utils/constant.js';
// import { isNewVersion } from '@/utils/systemUpdate.js';

class Permission {
    constructor(router) {
        router.beforeEach((to, from, next) => {

            // document.title = to.meta?.title || '汇正财经'
            // isNewVersion()

            const userAgent = navigator.userAgent.toLowerCase()
            if(userAgent.indexOf('micromessenger') == -1 && to.meta?.only_wechat) {
                next({path: '/notWechat', replace: true})
                return
            }

            if(to.params.sign) {
                const { sign } = to.params
                store.commit('live/setSign', sign)
                if(to.meta?.need_code) store.commit('live/setSign', sign.slice(0, -4)) // save sign like 'man_jglc1576' as 'man_jgcl'
            }

            // 自定义规则code验证
            if(to.meta?.need_code && to.params.sign) {
                const code_string = getCode()
                const { sign } = to.params
                if(code_string != sign.slice(-4)) return next({path: '/404', replace: true})
            }

            // pzzb gsbd 登录验证
            if(to.name == 'zblogin') {
                const token = cookies.get('zb_token')
                if(token) return next({ path: `/zbv2/${to.params.sign}`, replace: true })
            }
            if(to.name == 'hzlogin') {
                const token = cookies.get('zb_token')
                if(token) return next({ path: `/hzlive/${to.params.sign}`, replace: true })
            }

            next()
        })
    }
}

export default Permission